export default status => {
  return status.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());
};
